import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { RegistrationService } from '../registration.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {
  regForm: FormGroup;
  msg = '';
  successMsg = '';
  submitting = false;

  constructor(private fb: FormBuilder, private _service: RegistrationService, private _route: Router) {
    this.regForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      username: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.pattern('(?=.*\\d)(?=.*[a-zA-Z]).{6,}')]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordsMatch });
  }

  ngOnInit(): void {}

  passwordsMatch(group: AbstractControl) {
    const pwControl = group.get('password');
    const cpwControl = group.get('confirmPassword');
    const pw = pwControl ? pwControl.value : null;
    const cpw = cpwControl ? cpwControl.value : null;
    return pw === cpw ? null : { passwordMismatch: true };
  }

  registerUser() {
    if (this.regForm.invalid) {
      this.msg = 'Please fix validation errors.';
      return;
    }

    this.submitting = true;
    const payload = { ...this.regForm.value };
    delete payload.confirmPassword;

    this._service.registerUserFromRemote(payload).subscribe(
      data => {
        this.submitting = false;
        this.successMsg = 'Registration successful! Redirecting...';
        setTimeout(() => { this._route.navigate(['/user-profile']); }, 1000);
      },
      error => {
        this.submitting = false;
        console.error('Registration error', error);
        this.msg = 'Registration failed. Please try again.';
      }
    );
  }
}
